import React from 'react';
import {
  composeTimeInputValue,
  parseTimeInputValue,
  TIME_INPUT_HOURS,
  TIME_INPUT_MINUTES,
} from '../utils/timeInput';
import styles from './TimeInput24.module.css';

export type TimeInput24Props = Omit<React.HTMLAttributes<HTMLDivElement>, 'onChange'> & {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

export const TimeInput24: React.FC<TimeInput24Props> = ({
  value,
  onChange,
  className,
  disabled,
  id,
  ...rest
}) => {
  const parts = parseTimeInputValue(value);
  const hours = parts?.hours ?? '';
  const minutes = parts?.minutes ?? '';

  const updateHours = (nextHours: string) => {
    onChange(composeTimeInputValue(nextHours, minutes || '00'));
  };

  const updateMinutes = (nextMinutes: string) => {
    onChange(composeTimeInputValue(hours || '00', nextMinutes));
  };

  return (
    <div
      {...rest}
      id={id}
      aria-disabled={disabled || undefined}
      className={[styles.root, className].filter(Boolean).join(' ')}
    >
      <select
        className={styles.select}
        value={hours}
        disabled={disabled}
        aria-label="Hours"
        onChange={(event) => updateHours(event.target.value)}
      >
        <option value="">--</option>
        {TIME_INPUT_HOURS.map((option) => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>

      <span className={styles.separator} aria-hidden="true">:</span>

      <select
        className={styles.select}
        value={minutes}
        disabled={disabled}
        aria-label="Minutes"
        onChange={(event) => updateMinutes(event.target.value)}
      >
        <option value="">--</option>
        {TIME_INPUT_MINUTES.map((option) => (
          <option key={option} value={option}>{option}</option>
        ))}
      </select>
    </div>
  );
};
